import Vue from 'vue'
import bySrore from 'biyi-store'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
import App from './app.vue'
import util from './libs/util'
import router from './router/router'
import store from './store/store'
import VueI18n from 'vue-i18n'
import localeI18n from './i18n/index'
import { ButtonLimited } from 'biyi-admin'
import {
  Tree,
  Button,
  Switch,
  DatePicker,
  Descriptions,
  DescriptionsItem,
  Loading,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Tag,
  Carousel,
  CarouselItem,
  Steps,
  Step,
  Table,
  InputNumber,
  Autocomplete,
  Notification,
  Image,
} from 'element-ui'


import moment from 'moment'
// 导入比翼UI
import biyiUI from "biyi-ui"
// 导入比翼UI的样式
import "biyi-ui/src/biyi-ui.css"
// 引入animate.css
import 'animate.css'
// 引入百度地图
import BaiduMap from 'vue-baidu-map'
// 引入和风天气图标
import 'qweather-icons/font/qweather-icons.css'

Vue.use(BaiduMap, {
  ak: 'DeMrIzatabf5IUkmHah870RHzfbwm9YW'
})
Vue.use(Loading.directive)
Vue.config.productionTip = false
Vue.prototype.$util = util
Vue.prototype.$http = util.http
Vue.prototype.$moment = moment
Vue.prototype.$uploadUrl = util.baseUrl
Vue.prototype.$downloadUrl = 'https://oos-cn.ctyunapi.cn/emergency/'
Vue.prototype.$videoUrl = 'https://dzgllw.com'//'wss://dzgllw.com'//'ws://144.123.135.25:8091'//'https://dzgllw.com'
Vue.prototype.$notify = Notification
Vue.prototype.$loading = Loading.service;
Vue.prototype.$mapConfigKey = 'DeMrIzatabf5IUkmHah870RHzfbwm9YW'
Vue.prototype.$mapSignRangeKey = 'DeMrIzatabf5IUkmHah870RHzfbwm9YW'
Vue.use(bySrore)
Vue.use(VueI18n)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Checkbox)
Vue.use(Tag)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Tree)
Vue.use(Switch)
Vue.use(Button)
Vue.use(Image)
Vue.use(DatePicker)
Vue.use(DatePicker)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Table)
Vue.use(InputNumber)
Vue.use(Autocomplete)
Vue.use(Image)
Vue.use(Loading.directive)
Vue.use(biyiUI)
Vue.use(iView, {
  i18n: function (path, options) {
    let value = i18n.t(path, options)
    if (value !== null && value !== undefined) {
      return value
    }
    return ''
  }
})

Vue.component('Button', ButtonLimited)

Vue.locale = () => {
}

const i18n = new VueI18n(localeI18n)

const vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

export default vm
